module.exports = __webpack_public_path__ + "img/ic_kucun.42e99526.png";